import { Button } from '../../../../../components';
import { repository } from '@whizz/api-client';
import { useI18n } from '@whizz/react-i18n';
import type { AxiosError } from 'axios';
import type { SyntheticEvent } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { GLOBAL_ICONS, QUERIES_IDS } from '../../../../../util/vars';
import type { ClassModalProps } from './AddEditClassModal';
import { CancelButtonModal } from '../../../../../global';
import { ModalFooter } from '../../../../../components/modal/Modal';

const DeleteConfirmModal = ({ toggle, toggleConfirm, data, onSuccess, onError }: ClassModalProps): JSX.Element => {
  const { translate } = useI18n();
  const queryClient = useQueryClient();

  const mutationDelete = useMutation(
    (id: number) => repository.NewClassRepository.delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ QUERIES_IDS.ROSTER_MANAGEMENT.CLASSES ]);
        onSuccess?.();
      },
      onError: (error: AxiosError<{ error: string }>) => {
        if (null == error.response) {
          return;
        }
        onError?.();
      },
    },
  );

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    if (null == data?.id) {
      return;
    }

    mutationDelete.mutate(data.id);

    toggleConfirm(false);
  };

  const handleCancel = () => {
    toggleConfirm(false);
    toggle(true);
  };

  const WarningMessage = () =>
    <>
      <span className={'font-bold italic'}>
        {translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.DELETE_HINT_3', { class: data?.name })}
      </span>
      <p>{translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.DELETE_HINT_4')}</p>
    </>;

  const CancelButton = () =>
    <CancelButtonModal
      align={'start'}
      onClick={handleCancel}
    >{translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.BUTTONS.KEEP_CLASS')}</CancelButtonModal>;

  const ConfirmButton = () =>
    <Button
      color={'negative'}
      icon={GLOBAL_ICONS.delete}
      isOutline
      onClick={handleSubmit}
    >{translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.BUTTONS.CONFIRM_DELETION')}</Button>;

  return (
    <form onSubmit={handleSubmit}>
      <div className={'container space-y-6'}>
        <WarningMessage />
      </div>
      <ModalFooter>
        <CancelButton />
        <ConfirmButton />
      </ModalFooter>
    </form>
  );
};

export default DeleteConfirmModal;
